import { customInstance } from '@/features/auth/axios-config'
import {
  RequestAuditLog,
  SuccessResponseListAuditLogEntry,
  SuccessResponseListEntityAuditLogEntry,
} from '@/schema'

const API_ENDPOINT_AUDITS = '/admin/v1/audits'

export const auditLogApi = {
  /**
   * Fetch document view audit logs (returns User[] in data).
   * Used by ViewerTracker to show who viewed a document.
   */
  getAuditLogList: async (
    data: RequestAuditLog
  ): Promise<SuccessResponseListAuditLogEntry> => {
    return customInstance<SuccessResponseListAuditLogEntry>({
      method: 'post',
      url: `${API_ENDPOINT_AUDITS}/list`,
      data,
    })
  },

  /**
   * Fetch entity-level audit history (Company, Project, etc.).
   * Returns EntityAuditLogEntry[] grouped by the entity.
   */
  getEntityHistoryList: async (
    data: RequestAuditLog
  ): Promise<SuccessResponseListEntityAuditLogEntry> => {
    return customInstance<SuccessResponseListEntityAuditLogEntry>({
      method: 'post',
      url: `${API_ENDPOINT_AUDITS}/list`,
      data,
    })
  },

  exportHistory: async (data: RequestAuditLog): Promise<void> => {
    return customInstance<void>({
      method: 'post',
      url: `${API_ENDPOINT_AUDITS}/export`,
      data,
    })
  },
}
